import React from 'react'
import Link from 'shared-ui/components/Link'
import LogoSVG from 'shared-ui/assets/img/logo-black.svg'

const Logo = ({ platformName, className = '' }) => (
  <Link
    to="/"
    className={`flex flex-row items-start ml-4 ${className}`}
    style={{ direction: 'ltr' }}
  >
    <div className="flex">
      <LogoSVG />
    </div>
    <div className="flex flex-col justify-start ml-2 font-bold text-sm leading-none">
      {platformName}
    </div>
  </Link>
)

export default Logo
